export const findModuleByLocation = (loc: { pathname: string }): string => {
  const [, pathnamePOS, pathnameSettings] = loc.pathname.split("/");

  return (pathnamePOS !== "settings" ? pathnamePOS : pathnameSettings) ?? "";
};
